// =============================================
//  OficiAR — api.js (Cliente Axios)
//  Apunta al backend en Hostinger
// =============================================
import axios from "axios";
import { jwtDecode } from "jwt-decode";

// URL del backend según entorno
// En producción apunta a tu dominio en Hostinger
// En desarrollo apunta a localhost
const isProduction = process.env.NODE_ENV === 'production';

export const BACKEND_URL = isProduction
    ? 'https://oficiar-backend.onrender.com'
    : 'http://localhost:4000';

const api = axios.create({
    baseURL: `${BACKEND_URL}/api`,
    withCredentials: false,
    timeout: 15000, // 15 segundos máximo por request
});

// Interceptor de REQUEST: agrega el token JWT
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token && token !== "null" && token !== "undefined") {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// Interceptor de RESPONSE: maneja token expirado globalmente
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            // Token expirado o inválido → limpiar sesión y redirigir
            localStorage.removeItem('token');
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

// Utilidad: obtener el rol del usuario del token
export function getUserRole() {
    try {
        const token = localStorage.getItem("token");
        if (!token) return null;
        const decoded = jwtDecode(token);

        // Verificar si el token expiró
        if (decoded.exp && decoded.exp * 1000 < Date.now()) {
            localStorage.removeItem('token');
            return null;
        }

        return decoded.role;
    } catch {
        return null;
    }
}

// Utilidad: verificar si hay sesión activa
export function isLoggedIn() {
    return getUserRole() !== null;
}

export default api;